import * as React from "react";

export const IconZoomOut = (props: React.SVGProps<SVGSVGElement>): React.JSX.Element => (
  <svg width="1em" height="1em" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M12.5 3L14.4167 4.91667L12.0083 7.30833L13.1917 8.49167L15.5833 6.08333L17.5 8V3H12.5ZM2.5 8L4.41667 6.08333L6.80833 8.49167L7.99167 7.30833L5.58333 4.91667L7.5 3H2.5V8ZM7.5 18L5.58333 16.0833L7.99167 13.6917L6.80833 12.5083L4.41667 14.9167L2.5 13V18H7.5ZM17.5 13L15.5833 14.9167L13.1917 12.5083L12.0083 13.6917L14.4167 16.0833L12.5 18H17.5V13Z"
      fill="currentColor"
    />
  </svg>
);
